import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { FaInstagram, FaYoutube, FaFacebook, FaTiktok } from 'react-icons/fa';
import Logo from '../common/Logo';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Blog', href: '/blog' },
    { name: 'Gallery', href: '/gallery' },
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/contact' },
  ];

  const socialLinks = [
    {
      name: 'Instagram',
      icon: FaInstagram,
      href: 'https://www.instagram.com/rumonrahmanmd/',
      color: 'hover:text-pink-500',
    },
    {
      name: 'TikTok',
      icon: FaTiktok,
      href: 'https://www.tiktok.com/@rumonrehman?lang=en',
      color: 'hover:text-gray-900',
    },
    {
      name: 'YouTube',
      icon: FaYoutube,
      href: 'https://www.youtube.com/@mermaidsofthemoment',
      color: 'hover:text-red-500',
    },
    {
      name: 'Facebook',
      icon: FaFacebook,
      href: 'https://www.facebook.com/profile.php?id=100092539025966',
      color: 'hover:text-blue-600',
    },
  ];

  return (
    <header className="bg-white/80 backdrop-blur-md sticky top-0 z-50 border-b border-gray-100">
      <div className="container-max">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="rounded-2xl px-2 py-1 hover:shadow-md transition">
            <Logo size="md" showText={true} linkTo="/" />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-12">
            {navigation.map(item => (
              <Link
                key={item.name}
                to={item.href}
                className={`nav-link ${
                  location.pathname === item.href ? 'nav-link-active' : ''
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Social Media & Mobile Menu */}
          <div className="flex items-center space-x-6">
            {/* Social Media Links - Desktop */}
            <div className="hidden md:flex items-center space-x-4">
              {socialLinks.map(social => {
                const IconComponent = social.icon;
                return (
                  <a
                    key={social.name}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`social-icon ${social.color} rounded-xl bg-gray-50 hover:bg-white border border-gray-200 shadow-sm hover:shadow-md`}
                    aria-label={social.name}
                  >
                    <IconComponent className="w-5 h-5" />
                  </a>
                );
              })}
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden p-2 rounded-xl hover:bg-gray-100 transition-colors border border-gray-200 bg-white/70"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? (
                <XMarkIcon className="h-6 w-6" />
              ) : (
                <Bars3Icon className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden border-t border-gray-100 py-6 animate-slide-down bg-white/80 backdrop-blur-md rounded-b-2xl shadow-lg">
            <nav className="flex flex-col space-y-6">
              {navigation.map(item => (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={() => setIsMenuOpen(false)}
                  className={`text-lg font-medium text-gray-700 hover:text-gray-900 transition-colors px-4 ${
                    location.pathname === item.href
                      ? 'text-gray-900 font-semibold'
                      : ''
                  }`}
                >
                  {item.name}
                </Link>
              ))}

              {/* Mobile Social Links */}
              <div className="pt-6 border-t border-gray-100 px-4">
                <p className="text-sm font-medium text-gray-500 mb-4">
                  Follow Us
                </p>
                <div className="flex items-center space-x-6">
                  {socialLinks.map(social => {
                    const IconComponent = social.icon;
                    return (
                      <a
                        key={social.name}
                        href={social.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`social-icon ${social.color} rounded-xl bg-gray-50 hover:bg-white border border-gray-200 shadow-sm hover:shadow-md`}
                        aria-label={social.name}
                      >
                        <IconComponent className="w-6 h-6" />
                      </a>
                    );
                  })}
                </div>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
